export default "__VITE_ASSET__YPvCiMDj__"